import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
const StyledVerticalDivider = styled('div', {
    width: sizes.divider.thickness,
    height: '100%',
    backgroundColor: staticColors.divider,
    flex: '0 0 auto',
    alignSelf: 'stretch',
});
export const VerticalDivider = () => _jsx(StyledVerticalDivider, {});
